import { explicitLoggedOutRoutes } from 'assets/data/config';
import { globalKeys } from 'assets/data/global-keys';
import { shouldRedirectCampaign } from '~/utilities/campaign-utils';
import { useStorageService } from '~/composables/services/useStorageService';

export default defineNuxtRouteMiddleware((to) => {
  const $storageService = useStorageService();

  const accessToken = $storageService.getCookie<string>({
    key: globalKeys.authKeys.accessToken,
  });
  const refreshToken = $storageService.getCookie<string>({
    key: globalKeys.authKeys.refreshToken,
  });
  const isLoggedIn = !!accessToken || !!refreshToken;

  if (isLoggedIn && explicitLoggedOutRoutes.includes(to.path))
    return navigateTo('/', { replace: true });

  if (shouldRedirectCampaign(to.path, isLoggedIn))
    return navigateTo('/', { replace: true });
});
